import React, { useState } from 'react';

/**
 * ReadMoreSection - Expandable detailed description
 */
function ReadMoreSection({ task }) {
  const [expanded, setExpanded] = useState(false);
  
  // Skip if no substantial description
  if (!task.description || task.description.length < 100) return null;
  
  return (
    <div className="mb-5" data-testid="read-more-section">
      <button
        onClick={() => setExpanded(!expanded)}
        className="flex items-center gap-2 text-sm text-slate-400 hover:text-white transition-colors"
        data-testid="read-more-toggle"
      >
        <svg 
          className={`w-4 h-4 transition-transform ${expanded ? 'rotate-90' : ''}`} 
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
        </svg>
        <span className="font-medium">{expanded ? 'Skjul detaljer' : 'Les mer om denne oppgaven'}</span>
      </button>
      
      {expanded && (
        <div className="mt-3 bg-slate-800/50 border border-slate-700/50 rounded-xl p-4 animate-in slide-in-from-top-2 duration-200">
          <pre className="whitespace-pre-wrap font-sans text-slate-300 text-sm leading-relaxed">
            {task.description}
          </pre>
          
          {task.documentation_requirements && (
            <div className="mt-4 pt-4 border-t border-slate-700">
              <p className="text-xs font-semibold text-slate-400 uppercase tracking-wide mb-2">Dokumentasjonskrav</p>
              <pre className="whitespace-pre-wrap font-sans text-slate-400 text-sm leading-relaxed">
                {task.documentation_requirements}
              </pre>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default ReadMoreSection;
